module.exports = __webpack_public_path__ + "img/Newbie_Bow_01_Ranger.33b6ac5c.png";